module.exports = __webpack_public_path__ + "img/background-dark.0004d2cf.svg";